import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "С какими предприятиями вы работаете?",
    a: "Работаем с юридическими лицами и ИП по всей России: промышленные предприятия, транспортные и строительные компании, сельскохозяйственные предприятия, ЖКХ и организации с собственным парком техники.",
  },
  {
    q: "Как оформить заявку и получить коммерческое предложение?",
    a: "Отправьте запрос через форму на сайте, по e-mail или телефону. Укажите позиции, объём и желаемые сроки. В течение рабочего дня мы согласуем детали и подготовим коммерческое предложение.",
  },
  {
    q: "Какие условия оплаты и договор?",
    a: "Работаем по договору поставки. По умолчанию — безналичный расчёт с юрлицами и ИП. Условия оплаты (предоплата, отсрочка, поэтапная оплата) обсуждаются индивидуально для каждой сделки.",
  },
  {
    q: "Есть ли документы на продукцию?",
    a: "Да. Мы предоставляем полный пакет документов: счёт, УПД (или счёт-фактуру и накладную), сертификаты и паспорта на продукцию — в соответствии с требованиями законодательства.",
  },
  {
    q: "Как организована доставка?",
    a: "Отгружаем через транспортные компании и логистических партнёров по всей России. Также возможны самовывоз и организация доставки под ключ до склада заказчика.",
  },
  {
    q: "Можно ли заказать позиции, которых нет в стандартном перечне?",
    a: "Да. Работаем под запрос: подбираем аналоги, ищем нужные позиции у производителей и партнёров, оформляем разовые и регулярные поставки.",
  },
];

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="section bg-white relative"
    >
      <div className="container-x">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <div className="lg:sticky lg:top-32">
              <div className="eyebrow mb-6">Вопросы и ответы</div>
              <h2 className="font-display text-[#0A192F] text-3xl sm:text-4xl lg:text-5xl font-semibold leading-[1.1] tracking-tight">
                Часто задаваемые вопросы
              </h2>
              <p className="mt-6 text-slate-600 text-base leading-relaxed">
                Собрали ответы на самые частые B2B-вопросы. Не нашли нужное?
                Задайте вопрос через форму заявки — ответим в рабочее время.
              </p>
            </div>
          </div>
          <div className="lg:col-span-8">
            <Accordion
              type="single"
              collapsible
              className="w-full"
              data-testid="faq-accordion"
            >
              {FAQS.map((item, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  className="border-b border-slate-200"
                  data-testid={`faq-item-${i}`}
                >
                  <AccordionTrigger className="text-left py-6 hover:no-underline group">
                    <div className="flex items-start gap-4 pr-4">
                      <span className="text-xs font-semibold text-[#FF6B00] tabular-nums mt-1.5">
                        0{i + 1}
                      </span>
                      <span className="font-display text-[#0A192F] text-lg font-medium group-hover:text-[#FF6B00] transition-colors">
                        {item.q}
                      </span>
                    </div>
                  </AccordionTrigger>
                  <AccordionContent className="pb-6 pl-10 text-slate-600 text-base leading-relaxed">
                    {item.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
